import Constants from '@/Constants';
import { BatchFavoriteData } from '@/models/BatchFavoriteData';
import Category from '@/models/Category';
import http from '@/services/HttpService';
import { call, put } from 'redux-saga/effects';
import { PayloadAction } from 'typesafe-actions';
import { setSelectedCategories } from '../category/action';
import { removeContentFromList } from '../item/action';
import { removeCourseFromList } from '../list/action';
import { removeProgramFromList } from '../program/action';
import {
    batchFavoriteFailure,
    batchFavoriteSuccess,
    getFavoriteListFailure,
    getFavoriteListRequest as getFavoriteListRequestAction,
    getFavoriteListSuccess,
    removeCategoryFavoriteFailure,
    removeCategoryFavoriteSuccess,
    removeContentFavoriteFailure,
    removeContentFavoriteSuccess,
    removeCourseFavoriteFailure,
    removeCourseFavoriteSuccess,
    removeProgramFavoriteFailure,
    removeProgramFavoriteSuccess,
    setCategoryFavoriteFailure,
    setCategoryFavoriteSuccess,
    setContentFavoriteFailure,
    setContentFavoriteSuccess,
    setCourseFavoriteFailure,
    setCourseFavoriteSuccess,
    setProgramFavoriteFailure,
    setProgramFavoriteSuccess
} from './actions';
import { Favorite, FavoriteTypes } from './types';

const getSelectedCategories = (favoritesList: Favorite[]): Category[] => {
    const categoryList: Category[] = [];
    favoritesList &&
        favoritesList.length > 0 &&
        favoritesList
            .filter((f: Favorite) => f.contentType === 'CATEGORY')
            .forEach((f: Favorite) => {
                categoryList.push({ id: f.contentId } as Category);
            });
    return categoryList;
};

export function* getFavoriteListRequest(action: PayloadAction<FavoriteTypes.GET_FAVORITE_LIST_REQUEST, boolean>) {
    try {
        const response = yield call(http.get, Constants.FAVORITE_LIST_URI);
        yield put(getFavoriteListSuccess(response.data));
        if (action.payload) yield put(setSelectedCategories(getSelectedCategories(response.data)));
    } catch (error) {
        yield put(getFavoriteListFailure());
    }
}

export function* setFavoriteCourseRequest(action: PayloadAction<FavoriteTypes.SET_COURSE_FAVORITE_REQUEST, Favorite>) {
    try {
        const { contentId } = action.payload;
        yield call(http.post, Constants.FAVORITE_COURSE_URI.replace('%s', contentId.toString()));
        yield put(setCourseFavoriteSuccess(action.payload));
        yield put(getFavoriteListRequestAction());
    } catch (error) {
        yield put(setCourseFavoriteFailure());
    }
}

export function* removeFavoriteCourseRequest(action: PayloadAction<FavoriteTypes.REMOVE_COURSE_FAVORITE_REQUEST, Favorite>) {
    try {
        const { contentId } = action.payload;
        yield call(http.delete, Constants.FAVORITE_COURSE_URI.replace('%s', contentId.toString()));
        yield put(removeCourseFavoriteSuccess(action.payload));
        yield put(removeCourseFromList(contentId, 'listFavoriteStudentView'));
        yield put(getFavoriteListRequestAction());
    } catch (error) {
        yield put(removeCourseFavoriteFailure());
    }
}

export function* setFavoriteContentRequest(action: PayloadAction<FavoriteTypes.SET_CONTENT_FAVORITE_REQUEST, Favorite>) {
    try {
        const { contentId } = action.payload;
        yield call(http.post, Constants.FAVORITE_CONTENT_URI.replace('%s', contentId.toString()));
        yield put(setContentFavoriteSuccess(action.payload));
        yield put(getFavoriteListRequestAction());
    } catch (error) {
        yield put(setContentFavoriteFailure());
    }
}

export function* removeFavoriteContentRequest(action: PayloadAction<FavoriteTypes.REMOVE_CONTENT_FAVORITE_REQUEST, Favorite>) {
    try {
        const { contentId } = action.payload;
        yield call(http.delete, Constants.FAVORITE_CONTENT_URI.replace('%s', contentId.toString()));
        yield put(removeContentFavoriteSuccess(action.payload));
        yield put(removeContentFromList(contentId, 'listFavoriteStudentView'));
        yield put(getFavoriteListRequestAction(false));
    } catch (error) {
        yield put(removeContentFavoriteFailure());
    }
}

export function* setFavoriteCategoryRequest(action: PayloadAction<FavoriteTypes.SET_CATEGORY_FAVORITE_REQUEST, Favorite>) {
    try {
        const { contentId } = action.payload;
        yield call(http.post, Constants.FAVORITE_CATEGORY_URI.replace('%s', contentId.toString()));
        yield put(setCategoryFavoriteSuccess(action.payload));
        yield put(getFavoriteListRequestAction(false));
    } catch (error) {
        yield put(setCategoryFavoriteFailure());
    }
}

export function* setFavoriteProgramRequest(action: PayloadAction<FavoriteTypes.SET_PROGRAM_FAVORITE_REQUEST, Favorite>) {
    try {
        const { contentId } = action.payload;
        yield call(http.post, Constants.FAVORITE_PROGRAM_URI.replace('%s', contentId.toString()));
        yield put(setProgramFavoriteSuccess(action.payload));
        yield put(getFavoriteListRequestAction());
    } catch (error) {
        yield put(setProgramFavoriteFailure());
    }
}

export function* removeFavoriteCategoryRequest(action: PayloadAction<FavoriteTypes.REMOVE_CATEGORY_FAVORITE_REQUEST, Favorite>) {
    try {
        const { contentId } = action.payload;
        yield call(http.delete, Constants.FAVORITE_CATEGORY_URI.replace('%s', contentId.toString()));
        yield put(removeCategoryFavoriteSuccess(action.payload));
        yield put(removeContentFromList(contentId, 'listFavoriteStudentView'));
        yield put(getFavoriteListRequestAction());
    } catch (error) {
        yield put(removeCategoryFavoriteFailure());
    }
}

export function* removeFavoriteProgramRequest(action: PayloadAction<FavoriteTypes.REMOVE_PROGRAM_FAVORITE_REQUEST, Favorite>) {
    try {
        const { contentId } = action.payload;
        yield call(http.delete, Constants.FAVORITE_PROGRAM_URI.replace('%s', contentId.toString()));
        yield put(removeProgramFavoriteSuccess(action.payload));
        yield put(removeProgramFromList(contentId, 'listFavoriteStudentView'));
        yield put(getFavoriteListRequestAction());
    } catch (error) {
        yield put(removeProgramFavoriteFailure());
    }
}

export function* batchFavorite(action: PayloadAction<FavoriteTypes.BATCH_FAVORITE_REQUEST, BatchFavoriteData>) {
    const { entityType, favoriteIds } = action.payload;
    try {
        yield call(http.post, Constants.BATCH_FAVORITE_URI.replace('%s', entityType), favoriteIds);
        yield put(batchFavoriteSuccess());
        yield put(getFavoriteListRequestAction(false));
    } catch (error) {
        yield put(batchFavoriteFailure());
    }
}
